module.exports = __webpack_public_path__ + "img/S120.e7fef1c1.jpg";